import { render, staticRenderFns } from "./StructureAffiliationEditor.vue?vue&type=template&id=38a2d213&"
import script from "./StructureAffiliationEditor.vue?vue&type=script&lang=ts&"
export * from "./StructureAffiliationEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports